import React, { useState } from 'react';
import { BellRing, ClipboardCheck, Landmark } from 'lucide-react';
import AdSlot from '../advertisement/AdSlot';
import { DRHP_CHECKLIST } from '../../data/drhpTrackerData';

// merchantBankers: [{ name, count }] from utils/drhpTracker.js topMerchantBankers
export const DrhpSidebar = ({ merchantBankers, analysedCount, onAlertSignup }) => {
  const [contact, setContact] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    setContact('');
    onAlertSignup();
  };

  return (
    <aside className="space-y-5" aria-label="Research desk and partners">
      {/* Featured issue / partner ad (GET /api/ads): dedicated DRHP slot first, then the shared one */}
      <AdSlot slotId={['drhp-sidebar-top', 'incontent']} variant="compact" />

      <section aria-labelledby="drhp-checklist-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
        <p className="text-[10px] font-extrabold uppercase tracking-wider text-[#008080]">Research Desk Checklist</p>
        <h2 id="drhp-checklist-heading" className="mt-0.5 flex items-center gap-2 text-sm font-extrabold text-slate-900">
          <ClipboardCheck className="w-4 h-4 text-[#008080]" aria-hidden="true" />5 Things to Check in a DRHP
        </h2>
        <ol className="mt-3 space-y-2.5">
          {DRHP_CHECKLIST.map((item, index) => (
            <li key={item.title} className="flex gap-2.5">
              <span className="w-5 h-5 rounded-full bg-slate-900 text-white text-[10px] font-extrabold flex items-center justify-center flex-shrink-0">
                {index + 1}
              </span>
              <p className="text-xs text-slate-600 leading-relaxed">
                <strong className="text-slate-800">{item.title}:</strong> {item.body}
              </p>
            </li>
          ))}
        </ol>
      </section>
      {/* 
      <section aria-labelledby="drhp-alerts-heading" className="rounded-2xl border border-teal-200 bg-teal-50/60 p-4 sm:p-5">
        <h2 id="drhp-alerts-heading" className="flex items-center gap-2 text-sm font-extrabold text-slate-900">
          <BellRing className="w-4 h-4 text-[#008080]" aria-hidden="true" />
          Instant Filing Alerts
        </h2>
        <p className="mt-1 text-xs text-slate-600 leading-relaxed">Get notified as soon as a new DRHP or RHP is added to the registry.</p>
        <form onSubmit={handleSubmit} className="mt-3 space-y-2">
          <label htmlFor="drhp-alert-contact" className="sr-only">
            Email address
          </label>
          <input
            id="drhp-alert-contact"
            type="email"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            placeholder="Enter your email address"
            className="w-full px-3 py-2 rounded-lg border border-slate-200 bg-white text-xs text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#008080] focus:ring-1 focus:ring-[#008080]"
          />
          <button type="submit" className="w-full px-3 py-2 rounded-lg bg-[#008080] hover:bg-[#006666] text-xs font-extrabold text-white transition-colors">
            Activate Filing Alerts
          </button>
        </form>
      </section> */}

      <section aria-labelledby="drhp-bankers-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
        <h2 id="drhp-bankers-heading" className="flex items-center gap-2 text-xs font-extrabold uppercase tracking-wider text-slate-700">
          <Landmark className="w-4 h-4 text-[#008080]" aria-hidden="true" />
          Top Merchant Bankers
        </h2>
        {merchantBankers.length ? (
          <>
            <ul className="mt-2 divide-y divide-slate-100">
              {merchantBankers.map((banker) => (
                <li key={banker.name} className="flex items-center justify-between gap-3 py-2 text-xs">
                  <span className="font-semibold text-slate-700 truncate" title={banker.name}>
                    {banker.name}
                  </span>
                  <span className="font-bold text-[#008080] whitespace-nowrap">
                    {banker.count} {banker.count === 1 ? 'issue' : 'issues'}
                  </span>
                </li>
              ))}
            </ul>
            <p className="mt-2 text-[10px] text-slate-400">Book running lead managers across the {analysedCount} analysed DRHPs.</p>
          </>
        ) : (
          <p className="mt-2 text-xs text-slate-400">Lead managers appear once DRHPs are analysed.</p>
        )}
      </section>

      <AdSlot slotId={['drhp-sidebar-bottom', 'infeed']} variant="compact" />
    </aside>
  );
};

export default DrhpSidebar;
